// Module
var code = `<span class="conversation-state-chip text-white bg-harvustgreen" translate>newFeatureTag.NEW_FEATURE</span> `;
// Exports
export default code;